import {
  BASE_URL,
  USER_AUDIT_LOGS,
  TRANSACTION_AUDIT_LOGS,
  API_GATEWAY_KEY,
} from "./Constants";
import Cookies from "js-cookie";

export const fetchUserAuditLogs = async (pageNo, recordsPerPage) => {
  let response = await fetch(
    `${BASE_URL}${USER_AUDIT_LOGS}/${pageNo}/${recordsPerPage}`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
    }
  );
  return response;
};

export const fetchTransactionAuditLogs = async (pageNo, recordsPerPage) => {
  let response = await fetch(
    `${BASE_URL}${TRANSACTION_AUDIT_LOGS}/${pageNo}/${recordsPerPage}`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
    }
  );
  return response;
};
